<template>
    <div class="raffle-banner-slider relative w-full overflow-hidden">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(slide, i) in slides" :key="i">
                <img :src="slide" alt="HKCM Fußball-Aktion 2026" class="w-full h-auto rounded-2xl" />
            </div>
        </div>

        <div class="raffle-banner-button-prev text-white absolute left-2 top-1/2 -translate-y-1/2 z-10 cursor-pointer">
            <Icon type="TailLeft" viewBox="0 0 30 21" width="25" height="26" fill="none" class="stroke-current" />
        </div>
        <div class="raffle-banner-button-next text-white absolute right-2 top-1/2 -translate-y-1/2 z-10 cursor-pointer">
            <Icon type="TailRight" viewBox="0 0 30 21" width="25" height="26" fill="none" class="stroke-current" />
        </div>

        <div class="mt-2 flex justify-center gap-6 text-sm">
            <router-link to="/verlosungdatenschutz" class="text-gray-600 underline hover:text-gray-900">Datenschutz</router-link>
            <router-link to="/verlosung" class="text-gray-600 underline hover:text-gray-900">Teilnahmebedingungen</router-link>
        </div>
    </div>
</template>

<script>
import Swiper, { Navigation, Autoplay } from 'swiper';
import { asset } from '../helpers.js';

Swiper.use([Navigation, Autoplay]);

export default {
    name: 'RaffleProductBannerSlider',

    data: () => ({
        _swiper: null,
        slides: [
            asset('/hkcm/images/mkr_wm_banner_produktseite_01.jpeg', 'public'),
            asset('/hkcm/images/mkr_wm_banner_produktseite_02.jpeg', 'public'),
            asset('/hkcm/images/mkr_wm_banner_produktseite_03.jpeg', 'public')
        ]
    }),

    mounted() {
        this.$nextTick(() => this.init());
    },

    beforeUnmount() {
        this.destroy();
    },

    methods: {
        // Initialize swiper (destroy old instance if already running)
        init() {
            this.destroy();
            this._swiper = new Swiper('.raffle-banner-slider', {
                slidesPerView: 1,
                loop: true,
                grabCursor: true,
                autoplay: { delay: 5000, disableOnInteraction: false },
                navigation: {
                    nextEl: '.raffle-banner-button-next',
                    prevEl: '.raffle-banner-button-prev'
                }
            });
        },

        destroy() {
            if (this._swiper) {
                this._swiper.destroy(true, true);
                this._swiper = null;
            }
        }
    }
};
</script>
